/*
 * ce-text-marquee.js — Casper-ecom text marquee: measures one copy of the track and exposes its width
 * as `--ce-tm-copy-px` so the CSS animation runs at the merchant's speed (px per second) whatever the
 * rendered text width is. WHY JS: CSS cannot read the rendered width of the track into a duration.
 * Cost: one measurement on load and on resize (debounced); the motion itself stays a CSS animation.
 */
if (!customElements.get('ce-text-marquee')) {
  customElements.define(
    'ce-text-marquee',
    class CeTextMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ce-tm__track');
        this.copy = this.querySelector('.ce-tm__copy');
        if (!this.track || !this.copy) return;
        this.measure();
        this.onResize = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.measure(), 150);
        };
        window.addEventListener('resize', this.onResize);
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }
      measure() {
        const width = this.copy.getBoundingClientRect().width;
        if (width > 0) this.track.style.setProperty('--ce-tm-copy-px', Math.round(width));
      }
    }
  );
}
